export enum CommentPostType {
  MEDIA = 'MEDIA',
  EVENT = 'EVENT',
  /** 자유 게시판 */
  FREE = 'FREE',
  /** 회사 옆 맛집 게시판 */
  TOP_EATS = 'TOP_EATS',
  /** 숏폼 영상 */
  SHORTS_MEDIA = 'SHORTS_MEDIA',
  // 고객 요청 사항으로 게시판명만 '체력의 신' 으로 변경한 채 오픈 (2025. 08. 26)
  /** '<체력의 신> 챌린지' 게시판 */
  MENTIONS = 'MENTIONS',
  /** 회사 속 직무 게시판 */
  DEPARTMENT_BOARD = 'DEPARTMENT_BOARD',
  /** 회사 밖 소모임 게시판 */
  SOCIETY_BOARD = 'SOCIETY_BOARD',
  /** LG LIFE 공지 게시판 */
  ANNOUNCEMENT_BOARD = 'ANNOUNCEMENT_BOARD',
  /** 독서 챌린지게시판 */
  BOOKSTORE_BOARD = 'BOOKSTORE_BOARD',
}
